import { useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-hot-toast";
import { useEffect, useRef } from "react";

const Question = ({ state, dispatch, homework, exam }) => {
  const { ID } = useParams();
  const essayAnswerRef = useRef();
  const fileInputRef = useRef();

  const checkApi = homework
    ? process.env.REACT_APP_STUDENT_HOMEWORK_UPDATE_API
    : exam
      ? process.env.REACT_APP_STUDENT_TRIAL_EXAM_UPDATE_API
      : process.env.REACT_APP_STUDENT_QUIZZ_UPDATE_API;

  const buildAnswerPayload = ({
    questionId,
    n,
    order = null,
    essayText = "",
  }) => (exam ? {
    id: questionId,
    exam_id: ID,
    order,
    essay_text: essayText,
    n,
  } : {
    id: questionId,
    lecture_id: ID,
    order,
    essay_text: essayText,
    n,
  });

  const currentQuestion = state?.questions[state.currentQuestionIndex];
  const currentAnsweredQuestion = state.answeredQuestions.find(
    (question) => question?.id === currentQuestion?.id,
  );
  const currentFileName = currentAnsweredQuestion?.file?.name;
  const currentPreview =
    currentQuestion?.preview ||
    currentAnsweredQuestion?.preview ||
    currentQuestion?.draft ||
    null;

  const handleSelectAnswer = (answer, questionId, n) => {
    dispatch({
      type: "setAnsweredQuestions",
      payload: {
        id: questionId,
        order: answer,
        is_essay: 0,
        n,
        // file: fileInputRef.current.files[0],
      },
    });
    async function fetchData() {
      try {
        await axios.post(
          checkApi,
          buildAnswerPayload({
            questionId,
            order: answer,
            essayText: "",
            n,
          }),
        );
      } catch (error) {
        console.error("Error:", error);
        toast.error(error.response.data.message);
      }
    }

    fetchData();

    dispatch({
      type: "setIsSelectedAnswer",
      payload: { questionId, answer, n },
    });
  };

  const handleOnBlurEssayAnswer = (questionId, n) => {
    dispatch({
      type: "setAnsweredQuestions",
      payload: {
        id: questionId,
        order: essayAnswerRef.current.value,
        is_essay: 1,
        n,
        preview: currentAnsweredQuestion?.preview,
        file: currentAnsweredQuestion?.file,
      },
    });

    async function fetchData() {
      try {
        await axios.post(
          checkApi,
          buildAnswerPayload({
            questionId,
            order: null,
            essayText: essayAnswerRef.current.value,
            n,
          }),
        );
      } catch (error) {
        console.error("Error:", error);
        toast.error(error.response.data.message);
      }
    }

    fetchData();
  };

  const handleFileChange = async () => {
    const file = fileInputRef.current.files[0];
    if (!file) return;
    const questionId = state.questions[state.currentQuestionIndex].id;
    const essayText = essayAnswerRef.current.value;
    const n = state.questions[state.currentQuestionIndex].n;

    // Set image preview
    const reader = new FileReader();
    reader.onloadend = () => {
      dispatch({
        type: "setQuestionPreview",
        payload: {
          questionId,
          preview: reader.result,
        },
      });
      dispatch({
        type: "setAnsweredQuestions",
        payload: {
          id: questionId,
          order: essayText,
          is_essay: 1,
          n,
          file,
          preview: reader.result,
        },
      });
    };
    reader.readAsDataURL(file);

    const formData = new FormData();
    formData.append("id", questionId);
    if (exam) {
      formData.append("exam_id", ID);
    } else {
      formData.append("lecture_id", ID);
    }
    formData.append("order", "");
    formData.append("essay_text", essayText || "");
    formData.append("image", file);
    formData.append("n", n);

    try {
      await axios.post(checkApi, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      dispatch({
        type: "setAnsweredQuestions",
        payload: {
          id: questionId,
          order: essayText,
          is_essay: 1, // Assuming 1 indicates an essay
          n,
          file,
        },
      });
      toast.success("File uploaded successfully");
    } catch (error) {
      console.error("Error:", error);
      toast.error(
        error.response?.data?.message ||
          "An error occurred while uploading the file",
      );
    }
  };

  useEffect(() => {
    const currentAnswerd = state.answeredQuestions.filter(
      (question) =>
        question?.id === state?.questions[state.currentQuestionIndex]?.id,
    )[0];
    // if not essay question set textarea by the essay question value
    if (!state?.questions[state.currentQuestionIndex]?.answers) {
      if (
        state?.questions[state.currentQuestionIndex]?.answer ||
        currentAnswerd?.order
      ) {
        essayAnswerRef.current.value = currentAnswerd?.order
          ? currentAnswerd?.order
          : state?.questions[state.currentQuestionIndex]?.answer;
      } else {
        essayAnswerRef.current.value = "";
      }
    }
  }, [state.answeredQuestions, state.currentQuestionIndex, state?.questions]);

  useEffect(() => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }, [state.currentQuestionIndex]);

  return (
    <div className="container max-w-[600px]">
      <div className="current-question flex-row">
        {`${state.currentQuestionIndex + 1}.`}
        <div
          dangerouslySetInnerHTML={{
            __html: state.questions[state.currentQuestionIndex]?.question,
          }}
        />
      </div>

      <div className="current-question-degree flex items-center justify-end">
        <p> {state.questions[state.currentQuestionIndex]?.degree} Degree</p>
      </div>

      <div className="current-question-answers">
        {state?.questions[state.currentQuestionIndex]?.answers ? (
          <>
            {state?.questions[state.currentQuestionIndex]?.answers?.map(
              (answer, i) => (
                <div
                  key={i}
                  className={`${
                    state.questions[state.currentQuestionIndex]
                      .selected_answer === answer.order && "selected"
                  }`}
                  onClick={() =>
                    handleSelectAnswer(
                      answer.order,
                      currentQuestion.id,
                      currentQuestion.n,
                    )
                  }
                >
                  <span>{answer.order} </span>
                  <p dangerouslySetInnerHTML={{ __html: answer.answer }} />
                </div>
              ),
            )}
          </>
        ) : (
          <>
            <textarea
              ref={essayAnswerRef}
              onBlur={() =>
                handleOnBlurEssayAnswer(currentQuestion.id, currentQuestion.n)
              }
              placeholder="Write your answer"
              className="textareaQuiz !border-secondary !border-2 rounded-xl p-4 !placeholder:text-slate-400"
            ></textarea>
            <label
              for="formFileLg"
              class="mt-6 inline-block text-neutral-500 dark:text-neutral-400"
            >
              Upload Draft
            </label>
            <input
              class="relative m-0 block w-full min-w-0 flex-auto cursor-pointer rounded border border-solid border-secondary-500 bg-transparent bg-clip-padding px-3 py-[0.32rem] text-base font-normal leading-[2.15] text-surface transition duration-300 ease-in-out file:-mx-3 file:-my-[0.32rem] file:me-3 file:cursor-pointer file:overflow-hidden file:rounded-none file:border-0 file:border-e file:border-solid file:border-inherit file:bg-transparent file:px-3  file:py-[0.32rem] file:text-surface focus:border-primary focus:text-gray-700 focus:shadow-inset focus:outline-none dark:border-white/70 dark:text-white  file:dark:text-white"
              id="formFileLg"
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
            />
            {currentFileName ? (
              <p className="mt-2 text-sm text-secondary">{currentFileName}</p>
            ) : null}
          </>
        )}
      </div>
      {currentPreview ? (
        <div className="flex items-center justify-center">
          <img
            src={currentPreview}
            alt="Question draft preview"
            className="mt-10 h-[300px] max-w-full rounded-lg object-contain"
          />
        </div>
      ) : null}
    </div>
  );
};

export default Question;
